export default "__VITE_ASSET__BKJULnSw__"